import { Alert, Empty, Spin } from "antd"
import MarksTable from "../../admin/assignmentMarks/MarksTable";
import { useGetAssignmentMarksQuery } from "../../../features/assignmentMarks/assignmentMarksApi";
import { useEffect, useState } from "react";

export default function Assignments() {
  const [published, setPublished] = useState(0)

  const { data: assignments, isLoading, isError, error } = useGetAssignmentMarksQuery()

  // decide what to render 
  let render = null;
  if (isLoading) {
    render = <Spin />
  } else if (isError && error) {
    render = <Alert message="Error" description={typeof error?.data == 'string' ? error?.data : 'Something went wrong'}
      type="error"
      showIcon
    />
  } else if (!assignments?.length) {
    render = <Empty description="No Data Found" />
  } else {
    render = <MarksTable assignments={assignments} />
  }

  useEffect(() => {
    if (assignments && assignments?.length) {
      const totalPublished = assignments.filter(a => a.status == 'published').length;
      setPublished(totalPublished)
    }
  }, [assignments])

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-full px-5 lg:px-20">
        <div className="px-3 py-20 bg-opacity-10">
          {
            assignments?.length &&
            <ul className="assignment-status">
              <li>Total <span>{assignments?.length}</span></li>
              <li>Pending <span>{assignments?.length - published}</span></li>
              <li>Mark Sent <span>{published}</span></li>
            </ul>
          }
          <div className="overflow-x-auto mt-4">
            {render}
          </div>
        </div>
      </div>
    </section>
  )
}